module.exports = __webpack_public_path__ + "static/Grundfos-90b41cfd5cd1e554e9b7c68929a918f0.png";